(function () {
  function collectionTabs() {
    const collectionsTabs = document.querySelectorAll(".collection-tabs");
    if (!collectionsTabs.length) return;

    const collectionTabsWidth = window.innerWidth;

    collectionsTabs.forEach((tabs) => {
      const id = tabs.dataset.id;
      const collectionTabsElement = document.getElementById(`shopify-section-${id}`);
      if (!collectionTabsElement) return;

      const currentTabs = collectionTabsElement.querySelector(".collection-tabs");
      if (!currentTabs) return;

      const collectionTabsNavigation = currentTabs.querySelectorAll(".navigation-item");
      const collectionTabsNavigationSelect = currentTabs.querySelector(".tabs-navigation-select");
      const collectionTabsLists = currentTabs.querySelector(".collection-tabs-lists");
      const collectionTabsList = currentTabs.querySelectorAll(".collection-tabs-list");

      if (!collectionTabsNavigation.length || !collectionTabsLists || !collectionTabsList.length) return;

      const activateTab = (item) => {
        const tabId = item.dataset.tab;

        collectionTabsNavigation.forEach((element) => element.classList.remove("active"));
        collectionTabsList.forEach((element) => element.classList.remove("active"));

        item.classList.add("active");
        const activeList = collectionTabsLists.querySelector(`[data-tab-id="${tabId}"]`);
        if (activeList) activeList.classList.add("active");
      };

      if (collectionTabsWidth >= 750) {
        collectionTabsNavigation.forEach((item) => {
          item.addEventListener("click", () => activateTab(item));
          item.addEventListener("keyup", (event) => {
            if (event.key === "Enter" || event.key === "Space") {
              activateTab(item);
            }
          });
        });
      } else if (collectionTabsNavigationSelect) {
        collectionTabsNavigationSelect.addEventListener("change", () => {
          const selectedIndex = collectionTabsNavigationSelect.selectedIndex;
          const selectedItem = collectionTabsNavigation[selectedIndex];
          if (selectedItem) activateTab(selectedItem);
        });
      }
    });
  }

  document.addEventListener("DOMContentLoaded", collectionTabs);
  document.addEventListener("shopify:section:load", collectionTabs);
  window.addEventListener("resize", collectionTabs);
})();
